export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

export function formatError(detail) {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || String(item)).join(" ");
  return detail.msg || String(detail);
}

export async function apiFetch(path, options = {}) {
  const response = await fetch(`${API_URL}${path}`, {
    credentials: "include",
    ...options,
    headers: { ...(options.body instanceof FormData ? {} : { "Content-Type": "application/json" }), ...options.headers },
  });
  if (!response.ok) {
    let payload = {};
    try { payload = await response.json(); } catch (_) { /* non-json response */ }
    throw new Error(formatError(payload.detail) || `Request failed (${response.status})`);
  }
  return response.status === 204 ? null : response.json();
}

export function mediaUrl(url) {
  return url?.startsWith("/api/") ? `${BACKEND_URL}${url}` : url;
}